import { Injectable } from "@angular/core";
import { Store } from "../../../../@core/store/store";
import { Subject } from "rxjs";
import {
  ProfileLoadedState,
  ProfileLoadingErrorState,
  ProfileLoadingState,
  RequestsForAttendanceApprovalsLoadedState,
  RequestsForApprovalsLoadedState,
  RequestsForApprovalsLoadingErrorState,
  RequestsForApprovalsLoadingState,
  RequestsForAttendanceApprovalsLoadingErrorState,
  RequestsForAttendanceApprovalsLoadingState,
  RequestsForLeaveApprovalsLoadingState,
  RequestsForLeaveApprovalsLoadedState,
  RequestsForLeaveApprovalsLoadingErrorState,
  RequestsForCarApprovalsLoadedState,
  RequestsForCarApprovalsLoadingState,
  RequestsForCarApprovalsLoadingErrorState,
  RequestsForAccommodationApprovalsLoadingState,
  RequestsForAccommodationApprovalsLoadedState,
  RequestsForAccommodationApprovalsLoadingErrorState,
  SynergyPendingRequestsLoadingState,
  SynergyPendingRequestsLoadedState,
  SynergyPendingRequestsLoadingErrorState,
  ForexPendingRequestsLoadingState,
  ForexPendingRequestsLoadedState,
  ForexPendingRequestsLoadingErrorState,
  MyRequestLoadedState,
  MyRequestLoadingErrorState
} from "./header.state";
import { environment } from "../../../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class HeaderService extends Store.AbstractService {
  fetchProfileData(empId) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new ProfileLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.profile.userProfile.endpoint,
      { empId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new ProfileLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new ProfileLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchRequestsForApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.approvalRequests.endpoint,
      { emailId }
    );

    // const path = environment.api.intranet.approvalRequests.endpoint
    // const mockBase = "https://demo0404819.mockable.io/api/";

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchMyRequestsData(employeeId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.myRequest.endpoint,
      { employeeId }
    );


    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new MyRequestLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new MyRequestLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchRequestsForAttendanceApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForAttendanceApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.attendanceApprovalRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForAttendanceApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForAttendanceApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchRequestsForLeaveApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForLeaveApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.leaveApprovalRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForLeaveApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForLeaveApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
  
  fetchRequestsForCarApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForCarApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.carApprovalRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForCarApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForCarApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
  
  fetchRequestsForAccommodationApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new RequestsForAccommodationApprovalsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.accommodationApprovalRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new RequestsForAccommodationApprovalsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new RequestsForAccommodationApprovalsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

  fetchPendingSynergyRequests(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new SynergyPendingRequestsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.SynergyPendingRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new SynergyPendingRequestsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new SynergyPendingRequestsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

   fetchRequestsForForexApprovals(emailId: string): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
      output.next(new ForexPendingRequestsLoadingState());
    }, 0);
    const path = me.controller.replaceVariables(
      environment.api.intranet.forexRequest.endpoint,
      { emailId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new ForexPendingRequestsLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new ForexPendingRequestsLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
}
